import { UserApiData } from "@/modules/security/models/user-model";
import store from "../store";
import { useUser } from "@/composables/apiModels/useUser";
class ConfigService {
  institutionId(): number | null {
    const id: number = store.getters["security/getSelectedInstitution"]();
    if (id) {
      return id;
    } else {
      return null;
    }
  }

  APIInstitutionUrl(aSubPath: string): string {
    if (import.meta.env.VITE_VUE_APP_MOCKDATA === "true") {
      return "http://localhost/api/" + aSubPath;
    } else {
      return store.state.mainConfig.APP_API_URL + "/api/" + aSubPath;
    }
  }

  personaleOrAdminUrl(aSubPath: string): string {
    const user: UserApiData = store.getters["security/getUser"]();
    const { isEmployee } = useUser();
    if (import.meta.env.VITE_VUE_APP_MOCKDATA === "true") {
      return user && isEmployee(user)
        ? "http://localhost/api/personale/" + aSubPath
        : "http://localhost/api/" + aSubPath;
    } else {
      return user && isEmployee(user)
        ? store.state.mainConfig.APP_API_URL + "/api/personale/" + aSubPath
        : store.state.mainConfig.APP_API_URL + "/api/" + aSubPath;
    }
  }
}

// export a singleton instance in the global namespace
export const configService: ConfigService = new ConfigService();

export function ObjectFromEnvelope<T>(envelopedata: any): T {
  if (envelopedata.data === undefined) {
    throw new Error("Indeholder ikke data element i retur svaret");
  }
  return envelopedata.data as T;
}

export function ArrayFromEnvelope<T>(envelopedata: any): Array<keyof T> {
  if (envelopedata.data === undefined) {
    throw new Error("Indeholder ikke data element i retur svaret");
  }
  return [...envelopedata.data];
}
